interface Props {
  fill?: string;
  className?: string;
}

const PositiveDynamic = ({
  fill = '#39ca74',
  className = 'PositiveDynamic',
}: Props) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="5"
    height="9"
    viewBox="0 0 5 9"
    className={className}
  >
    <path
      id="Rounded-Rectangl"
      d="M4.854,2.855 C4.761,2.948 4.639,2.995 4.516,2.995 C4.394,2.995 4.272,2.948 4.179,2.855 C4.179,2.855 3.000,1.675 3.000,1.675 C3.000,1.675 3.000,8.375 3.000,8.375 C3.000,8.720 2.776,9.000 2.500,9.000 C2.224,9.000 2.000,8.720 2.000,8.375 C2.000,8.375 2.000,1.655 2.000,1.655 C2.000,1.655 0.801,2.855 0.801,2.855 C0.615,3.042 0.313,3.042 0.126,2.855 C-0.061,2.668 -0.061,2.366 0.126,2.179 C0.126,2.179 2.152,0.149 2.152,0.149 C2.242,0.060 2.363,0.009 2.490,0.009 C2.617,0.009 2.738,0.060 2.828,0.149 C2.828,0.149 4.854,2.179 4.854,2.179 C5.040,2.366 5.040,2.668 4.854,2.855 z"
      fill={fill}
    />
  </svg>
);

export default PositiveDynamic;
